import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatDivider } from '@angular/material/divider';
import { MatMenuModule } from '@angular/material/menu';
import { TrackByFunctions } from '@principle-theorem/ng-shared';
import { ChartSection } from '@principle-theorem/principle-core/interfaces';

@Component({
  selector: 'pr-chart-section-selector',
  templateUrl: './chart-section-selector.component.html',
  styleUrls: ['./chart-section-selector.component.sass'],
  imports: [CommonModule, MatButton, MatMenuModule, MatDivider],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChartSectionSelectorComponent {
  trackBySection = TrackByFunctions.variable<ChartSection>();
  sectionGroups: ChartSection[][] = [
    [ChartSection.BothArches, ChartSection.TopArch, ChartSection.BottomArch],
    [
      ChartSection.TopRight,
      ChartSection.TopLeft,
      ChartSection.BottomLeft,
      ChartSection.BottomRight,
    ],
  ];
  @Input() section: ChartSection = ChartSection.BothArches;
  @Output()
  selectionChange = new EventEmitter<ChartSection>();

  select(section: ChartSection): void {
    this.selectionChange.emit(section);
  }
}
